import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  XCircle,
  CreditCard,
  Home,
  RotateCcw,
  AlertCircle,
  ArrowRight
} from 'lucide-react';

const MPConnectionError: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll al top al montar
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        
        {/* Logo de Mercado Pago */}
        <div className="mb-6 flex justify-center">
          <div className="bg-white rounded-xl p-4 shadow-lg border-2 border-red-100">
            <img 
              src="https://http2.mlstatic.com/storage/logos-api-admin/a5f047d0-9be0-11ec-aad4-c3381f368aaf-xl@2x.png" 
              alt="Mercado Pago" 
              className="h-8 w-auto"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const parent = e.currentTarget.parentElement;
                if (parent) {
                  parent.innerHTML = '<span class="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">Mercado Pago</span>';
                }
              }}
            />
          </div>
        </div>

        {/* Ícono de error */}
        <div className="w-20 h-20 bg-gradient-to-br from-red-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
          <XCircle className="w-10 h-10 text-white" />
        </div>

        {/* Título */}
        <h1 className="text-3xl font-bold text-gray-900 mb-3 text-center">
          Error en la Vinculación
        </h1>
        
        <p className="text-gray-600 mb-6 text-center">
          No pudimos vincular tu cuenta de Mercado Pago. Por favor, intenta nuevamente.
        </p>

        {/* Posibles causas */}
        <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-5 mb-6 border border-orange-100">
          <h3 className="font-semibold text-gray-900 mb-4 text-center flex items-center justify-center gap-2">
            <AlertCircle className="w-5 h-5 text-orange-600" />
            Posibles Causas
          </h3>
          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-3 bg-white rounded-lg p-3">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full flex-shrink-0 mt-2"></div>
              <p className="text-gray-700">Cancelaste el proceso de autorización</p>
            </div>

            <div className="flex items-start gap-3 bg-white rounded-lg p-3">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full flex-shrink-0 mt-2"></div>
              <p className="text-gray-700">Hubo un problema de conexión</p>
            </div>

            <div className="flex items-start gap-3 bg-white rounded-lg p-3">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full flex-shrink-0 mt-2"></div>
              <p className="text-gray-700">Error temporal en Mercado Pago</p>
            </div>

            <div className="flex items-start gap-3 bg-white rounded-lg p-3">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full flex-shrink-0 mt-2"></div>
              <p className="text-gray-700">La sesión expiró durante el proceso</p>
            </div>
          </div>
        </div>

        {/* Mensaje de ayuda */}
        <div className="bg-blue-50 rounded-xl p-4 mb-6 border border-blue-100">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">¿Necesitas ayuda?</p>
              <p>Si el problema persiste, verifica que tu cuenta de Mercado Pago esté activa y que hayas aceptado los permisos solicitados.</p>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/professional/payment-config')}
            className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all flex items-center justify-center gap-2 group"
          >
            <RotateCcw className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500" />
            Intentar Nuevamente
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          
          <button
            onClick={() => navigate('/dashboard/profesional')}
            className="w-full bg-white border-2 border-gray-200 text-gray-700 py-3 rounded-xl font-medium hover:bg-gray-50 transition-all flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" />
            Volver al Dashboard
          </button>
        </div>

        {/* Footer note */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500 flex items-center justify-center gap-1">
            <CreditCard className="w-3 h-3" />
            No se realizaron cambios en tu cuenta
          </p>
        </div>
      </div>
    </div>
  );
};

export default MPConnectionError;